import { Component, OnInit } from '@angular/core';
import { AppState, actionsList } from '../shared/redux/store';
import { NgRedux } from '@redux/redux-compatibility.service';
import {
  DataElement,
  newCatSystemVersion,
  PaginationParams,
  ProcessRunStatusEnum,
  Product,
} from '../shared/models/common';
import { RevService } from '../shared/services/rev.service';
import {
  DirectLinkDoc,
  RevDoc,
  RevDocsSearchParams,
} from '../shared/models/rev.model';
import { ServiceMetaData } from '../shared/models/service-meta.model';
import { keyCodes } from '../shared/models/key-codes.model';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { SharedService } from '../shared/services/shared.service';
import { Unsubscribable } from 'rxjs';
import { Unsubscribe } from 'redux';
import { AuthService } from '../shared/services/auth.service';
import { CommonService } from '@shared/services/common.service';

@Component({
    selector: 'app-rev-doc-list',
    templateUrl: './rev-doc-list.component.html',
    styleUrls: ['./rev-doc-list.component.scss'],
    standalone: false
})
export class RevDocListComponent implements OnInit {
  loading: boolean;
  selectedDoc: RevDoc;
  rangeFrom: number;
  rangeTo: number;
  totalRecords: number;
  filterDocIdName: string;
  filterStatus: DataElement;
  filterProduct: DataElement;
  filterInactive: boolean;
  reduxSubscribe: Unsubscribe;
  displayAddRevDoc: boolean;
  createVersionParentDoc: RevDoc;
  searchParams: RevDocsSearchParams = {};
  getProcStatusFailedCnt: number = 0;
  processStatusTimers: ReturnType<typeof setInterval>[] = [];
  getProcessStatusIntervalSeconds: number = 5;
  displayProcessStatus: boolean;
  curDoc: RevDoc;
  docsBeingEdited: object = {};
  docsBeingUpdated: object = {};
  scrollContainer: HTMLElement;
  nextItemToLoad: number = 0;

  //renderedSize: number = 164.35; // header + filter;

  newCatSystemVersion = newCatSystemVersion;

  get docs(): RevDoc[] {
    return this.ngRedux.getState().revDocs;
  }

  get statusList(): DataElement[] {
    return this.ngRedux.getState().revDocStatusList;
  }

  get productList(): Product[] {
    return this.ngRedux.getState().productList;
  }

  get docsMetaData(): ServiceMetaData {
    const metaData: ServiceMetaData = this.ngRedux.getState().revDocsMetadata;
    return metaData || {};
  }

  get displayClearFilter(): boolean {
    return (
      this.filterDocIdName != null ||
      this.filterProduct != null ||
      this.filterStatus != null ||
      this.filterInactive
    );
  }

  get dlMode(): boolean {
    return (
      this.ngRedux.getState().dlRevDoc &&
      !this.ngRedux.getState().dlRevDoc.dlDocHandled
    );
  }

  constructor(
    private ngRedux: NgRedux<AppState>,
    private revService: RevService,
    private router: Router,
    private sharedService: SharedService,
    private authService: AuthService,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {}

  private scrollHandler = this.onScroll.bind(this);

  ngOnInit(): void {
    // reuse
    // this.router.events.subscribe((ev) => {
    //   if (
    //     this.ngRedux.getState().dlRevDoc &&
    //     this.ngRedux.getState().dlRevDoc.dlDocHandled &&
    //     ev instanceof ActivationEnd &&
    //     Object.is(ev?.snapshot?.component, RevDocListComponent)
    //   ) {
    //     this.getDocsHeader(true);
    //   }
    // });

    this.sharedService.putCookie('menu', 'rev', false);

    this.getDocsHeader(true);
    this.scrollContainer = document.querySelector('.main-content') as HTMLElement;

    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.scrollHandler);
    }
    
    this.reduxSubscribe = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.SELECT_ENV:
          this.getDocsHeader(true);
          break;
        case actionsList.USER_SIGN_OUT:
          this.processStatusTimers.forEach((t) => {
            clearInterval(t);
          });
          break;
      }
    });
    
  }
  onScroll(event: any) {

    if (this.loading || this.ngRedux.getState().revDocs.length >= this.docsMetaData.totalRecords) {
        return
    }
    const threshold = 100;
    const position = this.scrollContainer.scrollTop + this.scrollContainer.clientHeight;
    const height = this.scrollContainer.scrollHeight;

    if (height - position < threshold) {
      
      this.searchParams.rangeFrom = this.nextItemToLoad;
      this.searchParams.rangeTo = this.nextItemToLoad + 10;
      this.nextItemToLoad += 10;
      this.getDocsHeader(false);
    }
  }
  loadMoreIfNeeded() {

      if (this.hasVerticalScrollbar(this.scrollContainer) || this.loading || this.ngRedux.getState().revDocs.length >= this.docsMetaData.totalRecords) {
        return
      }
      this.searchParams.rangeFrom = this.nextItemToLoad;
      this.searchParams.rangeTo = this.nextItemToLoad + 10;
      this.nextItemToLoad += 10;
      this.getDocsHeader(false);
      setTimeout(() => this.loadMoreIfNeeded(), 1000);
      
      
  }
  ngOnDestroy(): void {
    this.processStatusTimers?.forEach((t) => {
      clearInterval(t);
    });

    if (this.reduxSubscribe) {
      this.reduxSubscribe();
    }
  if (this.scrollContainer && this.scrollHandler) {
    this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
  }
  }

  getDocsHeader(newSearch: boolean) {
    this.loading = true;

    if (newSearch) {
      
      this.nextItemToLoad = 0;
      this.searchParams.searchId = null;
      this.searchParams.rangeFrom = this.nextItemToLoad;
      this.searchParams.rangeTo = this.nextItemToLoad + 10;
      this.nextItemToLoad += 10;
    }
    this.searchParams.docId = null;

    if (this.dlMode) {
      this.searchParams.docId = this.ngRedux.getState().dlRevDoc.docId;
      this.searchParams.rangeTo = 2;
    }
    this.searchParams.docIdName = this.filterDocIdName;
    this.searchParams.product = this.filterProduct;
    this.searchParams.includeInactiveSw = this.filterInactive;
    this.searchParams.statusCode = this.filterStatus
      ? this.filterStatus.id
      : null;
    if (newSearch) {
      this.processStatusTimers.forEach((t) => {
        clearInterval(t);
      });

      this.processStatusTimers = [];
    }
    this.getProcStatusFailedCnt = 0;

    this.revService.getRevDocs(this.searchParams, true, newSearch).subscribe(
      (data) => {
        this.loading = false;

        let processingDocs = this.getProcessingDocs(this.docs);
        if (processingDocs.length > 0) {
          this.handleProcessingDocs(processingDocs);
        }

        this.sharedService.parseRunStatusMessageIfJSON(data);

        if (this.dlMode && data.length > 0 && !data[0].isProcessRunning) {
          this.viewDoc(data[0]);
        } else {
          this.ngRedux.dispatch({
            type: actionsList.SET_DL_REV_DOC,
            data: null,
          });
        }
      
/*       data.forEach((d) => {
        if (d.isProcessRunning) {
          this.renderedSize += 111.25;
        } else {
          this.renderedSize += 57.85;
        }
      }); */
      // Keep loading until scrollbars appear or data ends
      requestAnimationFrame(() => this.loadMoreIfNeeded());
            
      },
      (err) => (this.loading = false)
    );
  }
hasVerticalScrollbar(el: HTMLElement): boolean {
  return el.scrollHeight > el.clientHeight;
}
  private getProcessingDocs(docs: RevDoc[]): RevDoc[] {
    let processingDocs: RevDoc[] = [];

    (docs ?? []).forEach((doc) => {
      if (doc.isProcessRunning && doc.runNum) {
        processingDocs.push(doc);
      }

      (doc.docVersions ?? []).forEach((versionDoc) => {
        if (versionDoc.isProcessRunning && versionDoc.runNum) {
          processingDocs.push(versionDoc);
        }
      });
    });

    return processingDocs;
  }

  private updateLoadedDoc(docId: number, updatedDoc: RevDoc): void {
    let loadedDoc = this.docs.find((d) => d.docId == docId);

    if (!loadedDoc) {
      for (let doc of this.docs) {
        loadedDoc = (doc.docVersions ?? []).find((versionDoc) => versionDoc.docId == docId);
        if (loadedDoc) {
          break;
        }
      }
    }

    if (loadedDoc) {
      Object.assign(loadedDoc, updatedDoc);
    }
  }

  reloadSingleDoc(docId: number) {
    let searchParams = new RevDocsSearchParams();
    searchParams.docId = docId;

    this.revService.getRevDocs(searchParams, false).subscribe((data) => {
      if (data?.[0]) {
        this.updateLoadedDoc(docId, data[0]);
      }
    });
  }

  handleProcessingDocs(docs: RevDoc[]) {
    docs.forEach((d) => {
      let timer = setInterval(() => {
        this.authService.getProcessStatus(d.runNum).subscribe(
          (data) => {
            d.processStatus = data;
            let switched_to_pending_checks = d.runStatusCode == ProcessRunStatusEnum.RUNNING && data.status == ProcessRunStatusEnum.PENDING_CHECKS
            d.runStatusCode = data.status as string;
            if (
              data.status == ProcessRunStatusEnum.FINISHED ||
              data.status == ProcessRunStatusEnum.FAILED
            ) {
              clearInterval(timer);
              this.reloadSingleDoc(d.docId);
              if (this.curDoc && this.curDoc?.docId == d.docId) {
                this.displayProcessStatus = false;
              }
            }
            if (switched_to_pending_checks) {
              this.reloadSingleDoc(d.docId)
            }
          },
          (err) => {
            this.getProcStatusFailedCnt++;
            if (this.getProcStatusFailedCnt > 20) {
              clearInterval(timer);
            }
          }
        );
      }, this.getProcessStatusIntervalSeconds * 1000);

      this.processStatusTimers.push(timer);
    });
  }

  onPagination(event: PaginationParams) {
    if (
      !this.docs ||
      (event.rangeFrom == this.searchParams.rangeFrom &&
        event.rangeTo == this.searchParams.rangeTo)
    )
      return;

    this.searchParams.rangeFrom = event.rangeFrom;
    this.searchParams.rangeTo = event.rangeTo;
    this.searchParams.searchId =
      this.ngRedux.getState().revDocsMetadata.searchId;

    this.getDocsHeader(false);
  }

  onFilterKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.getDocsHeader(true);
    }
  }

  onFieldValueChanged(e: any) {
    if (e) (e.originalEvent as MouseEvent).stopPropagation();
    this.getDocsHeader(true);
  }

  clearFilter() {
    this.filterDocIdName = null;
    this.filterProduct = null;
    this.filterStatus = null;
    this.filterInactive = false;
    this.getDocsHeader(true);
  }

  viewDoc(doc: RevDoc) {
    this.commonService.getImageCategoriesForDocument(doc.docId, true).subscribe(() => {
      this.viewDocProcessing(doc);
    })
  }
  viewDocProcessing(doc: RevDoc) {
    let viewDoc;

    if (doc.docVersions.length > 0) {
      viewDoc = doc.docVersions.find((d) => d.versionId == doc.lastVersionId); //doc.docVersions[doc.docVersions.length - 1];
      viewDoc.newCatVersionSw = doc.newCatVersionSw;
    } else {
      viewDoc = doc;
    }

    this.ngRedux.dispatch({
      type: actionsList.SELECT_REV_DOC,
      data: viewDoc,
    });
    if (doc.versionId != null) {

      this.router.navigate([this.sharedService.routeEnum.URL_REV_DOC, doc.docId], { queryParams: { versionId: viewDoc.versionId } });
      return;

    }

      this.router.navigate([this.sharedService.routeEnum.URL_REV_DOC, doc.docId]);
  }

  onDocCreated(doc: RevDoc) {
    this.displayAddRevDoc = false;
    this.getDocsHeader(true);
  }

  openProcessStatus(doc: RevDoc, event: Event) {
    event.stopPropagation();  
    this.displayProcessStatus = true;
    this.curDoc = doc;
  }

  onClickEditDocName(event: Event, doc: RevDoc) {
    event.stopPropagation();
    this.docsBeingEdited[doc.docId] = { docName: doc.docName }
  }

  onClickCancelEditDocName(event: Event, docId: number) {
    event.stopPropagation();
    delete this.docsBeingEdited[docId];
  }

  onClickUpdateDocName(event: Event, docId: number) {
    event.stopPropagation();

    this.docsBeingUpdated[docId] = this.docsBeingEdited[docId];

    const docName = this.docsBeingUpdated[docId].docName;

    this.revService.renameRevDoc(docId, docName).subscribe(
      _ => {
        delete this.docsBeingUpdated[docId];
        delete this.docsBeingEdited[docId];

        let doc = this.docs.find(d => d.docId === docId);
        doc.docName = docName;
        doc.docVersions.forEach(dv => dv.docName = docName);
      },
      err => {
        delete this.docsBeingUpdated[docId];
        delete this.docsBeingEdited[docId];

        this.sharedService.showInfoMessage({infoType: 'error', messageKey: err,  showToast: false})
      }
    );
  }
  checkProcessStatusAndOpen(revDoc: RevDoc, event: Event) {

    if (revDoc.processStatus) {
      this.openProcessStatus(revDoc, event);
    }
  }
}
